<mat-checkbox
  [formControl]="control"
  (change)="inputChanged($event)"
>
  {{ label }}
</mat-checkbox>
